import styled from 'styled-components';

const MainWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
  text-align: center;
`;

const MainHeader = styled.h2`
  font-size: 2rem;
  letter-spacing: 0.1em;
`;

export const Main = () => (
  <MainWrapper>
    <MainHeader>Under Contruction</MainHeader>
    Diese Seite befindet sich derzeit im Aufbau
  </MainWrapper>
);
